// components/Technology.js
import React from 'react';
import { DevicePhoneMobileIcon, EyeIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';

const Technology = () => {
  return (
    <section className="py-16 bg-white" id="technology">
      <div className="container mx-auto text-center">
        <h3 className="text-primary uppercase font-semibold text-sm mb-2">Our Technology</h3>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Core Technology Stack</h2>
        <p className="text-gray-500 max-w-2xl mx-auto mb-10">
          Our technology enables accurate and efficient property analysis, benefiting various real estate applications.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center space-y-8 md:space-y-0 md:space-x-12">
          {/* Mobile LiDAR App */}
          <div className="text-center max-w-xs">
            <div className="flex justify-center mb-4">
              <div className="bg-yellow-500 p-4 rounded-full">
                <DevicePhoneMobileIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">Mobile LiDAR App</h4>
            <p className="text-gray-500">
              Our mobile app captures highly accurate property dimensions via room scanning, using iPhone technology. This tool has been available on iPhones since 2020 and continues to gain popularity.
            </p>
          </div>

          {/* MMLM Vision Models */}
          <div className="text-center max-w-xs">
            <div className="flex justify-center mb-4">
              <div className="bg-yellow-500 p-4 rounded-full">
                <EyeIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">MMLM Vision Models</h4>
            <p className="text-gray-500">
              Advanced image recognition models capable of detailed property analysis without pre-training, ensuring faster and more cost-effective implementation.
            </p>
          </div>

          {/* External Property Valuation Services */}
          <div className="text-center max-w-xs">
            <div className="flex justify-center mb-4">
              <div className="bg-yellow-500 p-4 rounded-full">
                <DocumentChartBarIcon className="h-8 w-8 text-white" />
              </div>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">External Property Valuation Services</h4>
            <p className="text-gray-500">
              Integrates real-time property valuation updates based on data captured, adding valuable market insights and enabling new applications for industry use.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
